// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"110":"39b28b89","637":"657b1f89"}[chunkId] + ".chunk.css";
};